module.exports = __webpack_public_path__ + "static/img/u72.0212b32a.png";